module.exports = __webpack_public_path__ + "img/sample-broadcaster-profile-pics.1429ecc.png";